module.exports = __webpack_public_path__ + "static/linen-2e65c3cf5d5fffe079877868a339e7b4.png";